import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowsAltV,faEdit,faTrashAlt,faAlignLeft,faAlignCenter,faAlignRight} from '@fortawesome/free-solid-svg-icons'

export default class extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {}
  }

  render()
  {
    var opacity = this.props.opacity || 1;
    var isSelected = this.props.isSelected || false;
    var isAllowEdit = this.props.isAllowEdit || false;
    var suffixes = isSelected ? (this.props.suffixes || null) : null;

    //console.log("//render")
    var position = this.props.item.hasOwnProperty('_attributes') ? (this.props.item._attributes.position) : false;
    return (
        <div id={`card-`+(this.props.index)} className={`item`}>
          <div className={`storycard ${isSelected && `selected`} `} style={Object.assign({}, this.props.style, { opacity })}>
            <div style={{display: `flex`, flexDirection: `row`}}>
              <div style={{flex: 1, minWidth: 0, maxWidth: 220, marginRight: 10}}>
                <div style={{
                  whiteSpace: `nowrap`,
                  overflow: `hidden`,
                  textOverflow: `ellipsis`,
                }}>
                  {this.props.children}
                </div>
              </div>

              <div style={{display: `flex`, flexDirection: `column`, flex: `0 0 100px`, alignItems: `flex-end`}}>
                <div style={{display: `flex`, flexDirection: `row`, justifyContent: `space-around`,height:`30px`}}>                
                {/*}
                  <div style={{flex: `0 0 40px`}} onClick={(e) => {
                    e.stopPropagation();
                    this.props.onShiftUp && this.props.onShiftUp();
                  }}>
                    <FontAwesomeIcon icon={faArrowAltCircleUp} size="lg" title="上移"/>                    
                  </div>
                  <div style={{flex: `0 0 40px`}} onClick={(e) => {
                    e.stopPropagation();
                    this.props.onShiftDown && this.props.onShiftDown();
                  }}>
                    <FontAwesomeIcon icon={faArrowAltCircleDown} size="lg" title="向下"/>
                  </div>
                */}

                  <div style={{width: `40px`}} className={`text-center`} onClick={(e) => {
                    e.stopPropagation();
                    this.props.onShiftOrder && this.props.onShiftOrder();
                  }}>
                    <FontAwesomeIcon icon={faArrowsAltV} size="lg" title="移動次序"/>
                  </div>

                  <div style={{width: `40px`}} className={`text-center`} onClick={(e) => {
                    e.stopPropagation();
                    this.props.onRemove && this.props.onRemove();
                  }}>
                    <FontAwesomeIcon icon={faTrashAlt} size="lg" title="刪除"/>
                  </div>

                </div>
                <div style={{display: `flex`, flexDirection: `row`, justifyContent: `space-around`,height:`30px`}}>
                  {
                    isAllowEdit && position=='left' ? (
                        <div style={{width: `40px`}} className={`text-center`} onClick={(e) => {
                          e.stopPropagation();
                          this.props.onShiftAlign && this.props.onShiftAlign();
                        }}>
                          <FontAwesomeIcon icon={faAlignLeft} size="lg" title="置左"/>
                        </div>
                    ) : (
                      null
                    )
                  }

                  { //disable this for Narrative
                    0 && isAllowEdit && position=='center' ? (
                        <div style={{width: `40px`}} className={`text-center`} onClick={(e) => {
                          e.stopPropagation();
                          this.props.onShiftAlign && this.props.onShiftAlign();
                        }}>
                          <FontAwesomeIcon icon={faAlignCenter} size="lg" title="置左"/>
                        </div>
                    ) : (
                      null
                    )
                  }

                    {   
                    isAllowEdit && position=='right' ? (
                        <div style={{width: `40px`}} className={`text-center`} onClick={(e) => {
                          e.stopPropagation();
                          this.props.onShiftAlign && this.props.onShiftAlign();
                        }}>
                          <FontAwesomeIcon icon={faAlignRight} size="lg" title="置左"/>
                        </div>
                    ) : (
                      null
                    )
                  }


                  {
                    isAllowEdit ? (
                        <div style={{width: `40px`}} className={`text-center`} onClick={(e) => {
                          e.stopPropagation();
                          this.props.onSelect && this.props.onSelect();
                        }}>
                          <FontAwesomeIcon icon={faEdit} size="lg" title="編輯"/>
                        </div>
                    ) : //// for icons alignment
                    (
                      <div style={{width: `40px`}} className={`text-center`}>
                          <FontAwesomeIcon icon={faEdit} size="lg" color="#eeeeee"/>
                      </div>
                    )
                  }                  
                  
                </div>
              </div>
            </div>
            {suffixes}
          </div>
        </div>
    )
  }
}